export default "__VITE_ASSET__CNl015uz__"